import configuracoesGerais from "@/modules/ConfiguracoesGerais/Index.vue";

export default [
  {
    path: "/gerais",
    component: configuracoesGerais,
    meta: { title: "Configurações Gerais" },
  },
];
